<template>
	<div>
		<section class="container-fluid mt-2">
			<Menu :isInOportunidad="true" :pShowReturn="false" :isInContactos="true" :pSitio="'Client View'">
			</Menu>

			<div class="row">
				<div class="col-md-12 col-lg-12 col-xl-12 mt-2">
					<Clist
						:isCrm="true"
						:isContactos="true"
						@FiltrarC="Lista"
						:Filtro="Filtro"
						:regresar="ShowBtns"
						:pShowBtnAdd="ShowBtns"
						:Nombre="NameList"
						:isModal="EsModal"
						:pConfigLoad="ConfigLoad"
						:ShowHead="false"
					>
						<template slot="cards">
							<div class="row row-cols-md-4 row-cols-lg-4 row-cols-xl-2 mt-3">
								<div v-for="(lista,key,index) in ListaClientes" :key="index" class="col-md-4 col-lg-4 col-xl-2 card-group">
									<div class="card mb-3 tarjetacliente" style="border:2px solid #0F3F87;cursor:pointer;border-radius:5px;"  @click="go_to_sucursal(lista)">
										<img height="160px" v-if="lista.LogoCliente!=null && lista.LogoCliente!=''" class="card-img-top" :src="Ruta+lista.LogoCliente" alt=""/>
        			                    <div height="160px" v-else class="card-img-top" src="" alt="" style="background-color:#b4b4b4;padding:75px"></div>
										<div class="card-body pt-2">
											<div class="row mt-1">
												<div class="col-lg-12">
													<div style="min-height:38px;">
														<h6 class="m-0">{{lista.Nombre.toUpperCase() }}</h6>
													</div>
													<div class="row">
														<div class="col-lg-12">
															<b>Propiedades: {{lista.Cantidad}}</b>
														</div>
													</div>
													<div class="row">
														<div class="col-lg-12">
															<b>Activos: {{lista.ContadorActivos}}</b>
														</div>
													</div>
													<div class="row mt-2">
														<div class="col-lg-2">
															<div>
																<div style="background-color:#2ecc71;height:20px;border-radius:50%;-moz-border-radius:50%;-webkit-border-radius:50%;width:20px;"></div>
															</div>	
														</div>
														<div class="col-lg-2 p-0">
															<b style="font-size:16px">{{lista.ContadorOperando}}</b>
														</div>
														<div class="col-lg-2">
															<div>
																<div style="background-color:#FFA426;height:20px;border-radius:50%;-moz-border-radius:50%;-webkit-border-radius:50%;width:20px;"></div>
															</div>	
														</div>
														<div class="col-lg-2 p-0">
															<b style="font-size:16px">{{lista.ContadorObservacion}}</b>
														</div>
														<div class="col-lg-2">
															<div>
																<div style="background-color:red;height:20px;border-radius:50%;-moz-border-radius:50%;-webkit-border-radius:50%;width:20px;"></div>
															</div>	
														</div>
														<div class="col-lg-2 p-0">
															<b style="font-size:16px">{{lista.ContadorFueraServicio}}</b>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</Clist>
				</div>
			</div>
		</section>

		<Modal :size="size" :Nombre="NameList">
			<template slot="Form"> </template>
		</Modal>
	</div>
</template>
<script>
import Modal from "@/components/Cmodal.vue";
import Clist from "@/components/Clist.vue";
import CSinRegistros from "../../../components/CSinRegistros";
import Menu from "./indexMenu.vue";
export default {
	name: "list",
	props: ["tipolistp"],
	components: {
		Modal,
		Clist,
		CSinRegistros,
		Menu
	},
	data() {
		return {
			FormName: "clientesForm", //Por si no es modal y queremos ir a una vista declarada en el router
			EsModal: true, //indica si es modal o no
			size: "modal-xl",
			NameList: "Client View",
			urlApi: "monitoreo/custumers",
			ListaClientes: [],
			ShowBtns: false,
			TipoList: "",
			Filtro: {
				Nombre: "",
				Placeholder: "Cliente..",
				TotalItem: 0,
				Pagina: 1,
				Entrada: 30
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			Ruta:''
		};
	},
	methods: {
		async Lista() {
			this.ConfigLoad.ShowLoader = true;
			await this.$http
				.get(this.urlApi, {
					params: {
						Nombre: this.Filtro.Nombre,
						Entrada: this.Filtro.Entrada,
						pag: this.Filtro.Pagina,
						RegEstatus: "A"
					}
				})
				.then(res => {
					this.ListaClientes = res.data.data.clientes;
					this.Ruta=res.data.ruta;
					this.Filtro.Entrada = res.data.data.pagination.PageSize;
					this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader = false;
				});
		},
		go_to_sucursal(objcliente) {
			this.$router.push({
				name: "mon_sucursal",
				params: { ocliente: objcliente }
			});
		},
		go_to_cotizacion(objcliente, Tipo) {
			this.$router.push({
				name: "mon_cotizacion",
				params: { ocliente: objcliente, pTipo: Tipo }
			});
		},
		got_to_seguimiento(objcliente) {
			this.$router.push({
				name: "mon_solicitudes",
				params: { ocliente: objcliente }
			});
		},
		// REASIGNACION
		// go_to_reasignacion(objcliente){
		// 	sessionStorage.setItem('IdSaved',JSON.stringify(objcliente));
		// 	this.$router.push({
		// 		name: "reasignacion",
		// 		params: { }
		// 	});
		// }
	},
	created() {
		this.bus.$off("List");
		this.bus.$off("Regresar");
		this.Lista();

		this.bus.$on("List", () => {
			this.Lista();
		});
	}
};
</script>
